/*
  Auto-generated by Spline
*/

import useSpline from '@splinetool/r3f-spline'

export default function Scene({ ...props }) {
    const { nodes, materials } = useSpline('https://prod.spline.design/LVjoItBYjo-mevDZ/scene.splinecode')
    return (
        <>
            <color attach="background" args={['#fceadc']} />
            <group {...props} dispose={null}>
                <mesh
                    name="Ball"
                    geometry={nodes.Ball.geometry}
                    material={materials.Character}
                    castShadow
                    receiveShadow
                    position={[-365.52, 58.35, 115]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    scale={1}
                />
                <mesh
                    name="ground"
                    geometry={nodes.ground.geometry}
                    material={materials.Ground}
                    castShadow
                    receiveShadow
                    position={[67.84, -349.49, -81.5]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    scale={1}
                />
                <group name="Tower" position={[-1353.41, 231.79, 785.76]} scale={[2.37, 2, 2]}>
                    <mesh
                        name="Cube 53"
                        geometry={nodes['Cube 53'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[-2.83, 98, 1.24]}
                        rotation={[-Math.PI / 2, 0, -0.77]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 531"
                        geometry={nodes['Cube 531'].geometry}
                        material={materials.tree}
                        castShadow
                        receiveShadow
                        position={[2.92, 49, -1.83]}
                        rotation={[-Math.PI / 2, 0, -0.86]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 532"
                        geometry={nodes['Cube 532'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[1.22, 0, 0.83]}
                        rotation={[-Math.PI / 2, 0, -0.57]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 533"
                        geometry={nodes['Cube 533'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[-1.51, -49, -0.92]}
                        rotation={[-Math.PI / 2, 0, -0.42]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 534"
                        geometry={nodes['Cube 534'].geometry}
                        material={materials.red}
                        castShadow
                        receiveShadow
                        position={[-1.44, -98, 2.33]}
                        rotation={[-Math.PI / 2, 0, -0.6]}
                        scale={1}
                    />
                </group>
                <group name="Group 81" position={[-1453.82, 1699.98, 1040.33]}>
                    <mesh
                        name="A"
                        geometry={nodes.A.geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-371.02, -131.85, -15.87]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={2.64}
                    />
                    <mesh
                        name="Triangle 3"
                        geometry={nodes['Triangle 3'].geometry}
                        material={materials['yellow-lighr']}
                        castShadow
                        receiveShadow
                        position={[-271.68, 76.19, -142.58]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={0.78}
                    />
                    <mesh
                        name="Triangle 2"
                        geometry={nodes['Triangle 2'].geometry}
                        material={materials.red}
                        castShadow
                        receiveShadow
                        position={[114.62, -137.49, 26.77]}
                        rotation={[-Math.PI / 2, 0, -1.34]}
                        scale={1}
                    />
                    <mesh
                        name="Triangle 4"
                        geometry={nodes['Triangle 4'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[180.88, -137.61, -118.01]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={[1.41, 1.41, 1]}
                    />
                    <mesh
                        name="Triangle"
                        geometry={nodes.Triangle.geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-148.07, 134.52, -97.59]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={[1.41, 1.41, 1]}
                    />
                    <mesh
                        name="Boolean 9"
                        geometry={nodes['Boolean 9'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[-432.05, -123.42, -97.29]}
                        rotation={[-Math.PI / 2, 0, 0.17]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 12"
                        geometry={nodes['Boolean 12'].geometry}
                        material={materials['Boolean 12 Material']}
                        castShadow
                        receiveShadow
                        position={[-355, -131.4, -201.32]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 8"
                        geometry={nodes['Boolean 8'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[-369.12, -5.56, -162.55]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 6"
                        geometry={nodes['Cone 6'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[443.44, -103.77, -245.65]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 8"
                        geometry={nodes['Cone 8'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[-359.1, -125.75, -92.72]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 10"
                        geometry={nodes['Cone 10'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[158.25, -124.94, -400.38]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 9"
                        geometry={nodes['Cone 9'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[188.32, 38.81, -232.04]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 7"
                        geometry={nodes['Cylinder 7'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[190.89, 10.58, -230.88]}
                        rotation={[0, -0.82, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 5"
                        geometry={nodes['Cylinder 5'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[90.56, -48.11, -353.49]}
                        rotation={[0, -0.82, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 9"
                        geometry={nodes['Cylinder 9'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[160.16, -123.34, 65.13]}
                        rotation={[0, 0.44, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 28"
                        geometry={nodes['Cylinder 28'].geometry}
                        material={materials['yellow-light-2']}
                        castShadow
                        receiveShadow
                        position={[72.23, -120.03, 210.31]}
                        rotation={[0, 0.47, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 8"
                        geometry={nodes['Cylinder 8'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-329.66, -129.46, 28.52]}
                        rotation={[0, 0.01, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cylinder 4"
                        geometry={nodes['Cylinder 4'].geometry}
                        material={materials.orange}
                        castShadow
                        receiveShadow
                        position={[-409.78, -112.17, -177.35]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Pyramid 3"
                        geometry={nodes['Pyramid 3'].geometry}
                        material={materials.orange}
                        castShadow
                        receiveShadow
                        position={[108.64, -56.2, -229.07]}
                        rotation={[0, -0.82, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Pyramid 2"
                        geometry={nodes['Pyramid 2'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[64.18, -116.66, -382.11]}
                        rotation={[0, -0.82, 0]}
                        scale={1}
                    />
                    <group name="Group 53" position={[55.56, -102.1, 17.84]} rotation={[0, -0.02, 0]} scale={1}>
                        <mesh
                            name="Sphere"
                            geometry={nodes.Sphere.geometry}
                            material={materials['yellow-lighr']}
                            castShadow
                            receiveShadow
                            position={[0, 25.36, 0]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            scale={1}
                        />
                        <mesh
                            name="Cube 3"
                            geometry={nodes['Cube 3'].geometry}
                            material={materials.orange}
                            castShadow
                            receiveShadow
                            position={[0, -25.36, 0]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            scale={1}
                        />
                    </group>
                    <mesh
                        name="Cube 14"
                        geometry={nodes['Cube 14'].geometry}
                        material={materials.orange}
                        castShadow
                        receiveShadow
                        position={[21.84, -99.27, -20.25]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 8"
                        geometry={nodes['Cube 8'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-229.59, -99.27, -108.51]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 5"
                        geometry={nodes['Cube 5'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-103.87, -26.18, -66.01]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 10"
                        geometry={nodes['Boolean 10'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-27.3, -62.1, -38.24]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 7"
                        geometry={nodes['Boolean 7'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-278.73, -62.1, -129.75]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 11"
                        geometry={nodes['Boolean 11'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[108.51, -123.14, 193.19]}
                        rotation={[-Math.PI / 2, 0, -1.08]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 6"
                        geometry={nodes['Boolean 6'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-153.01, 10.99, -83.99]}
                        rotation={[0, -Math.PI / 9, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 13"
                        geometry={nodes['Cube 13'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-275.56, 49.77, -131.91]}
                        rotation={[0, 1.22, -Math.PI / 2]}
                        scale={0.78}
                    />
                    <mesh
                        name="Cube 54"
                        geometry={nodes['Cube 54'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[39.46, -126.25, 164.39]}
                        rotation={[0, 0.81, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 535"
                        geometry={nodes['Cube 535'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-23.15, -126.25, 258.42]}
                        rotation={[0, 0.2, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 58"
                        geometry={nodes['Cube 58'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[11.34, -97.13, 179.17]}
                        rotation={[-Math.PI, 0.76, Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 7"
                        geometry={nodes['Cube 7'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[-20.16, -126.25, 190.73]}
                        rotation={[0, 1.22, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 27"
                        geometry={nodes['Cube 27'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[185.44, -123.05, -13.08]}
                        rotation={[0, 1.22, -Math.PI]}
                        scale={[1.41, 1, 1.41]}
                    />
                    <mesh
                        name="Cube 6"
                        geometry={nodes['Cube 6'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-153.05, 86.59, -83.9]}
                        rotation={[0, 1.22, -Math.PI / 2]}
                        scale={[1.41, 1, 1.41]}
                    />
                    <mesh
                        name="Cube 29"
                        geometry={nodes['Cube 29'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[85.86, -123.05, -92.72]}
                        rotation={[0, 0.45, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 18"
                        geometry={nodes['Cube 18'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[136.93, -123.05, -226.01]}
                        rotation={[0, 0.93, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 20"
                        geometry={nodes['Cube 20'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[180.11, -93.92, -225.25]}
                        rotation={[-Math.PI, 0.9, Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 19"
                        geometry={nodes['Cube 19'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[133.34, -93.92, -252.3]}
                        rotation={[Math.PI, 0.73, Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 17"
                        geometry={nodes['Cube 17'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[175.61, -123.05, -263.03]}
                        rotation={[0, 0.75, -Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 21"
                        geometry={nodes['Cube 21'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[190.89, -40.59, -230.88]}
                        rotation={[-Math.PI / 2, 0, -0.82]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 15"
                        geometry={nodes['Cube 15'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[90.56, -99.27, -353.49]}
                        rotation={[-Math.PI / 2, 0, -0.82]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 10"
                        geometry={nodes['Cube 10'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-382.67, -99.27, -167.48]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 12"
                        geometry={nodes['Cube 12'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[-290.09, 15.7, -133.78]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={[1, 1, 0.61]}
                    />
                    <mesh
                        name="Cube 9"
                        geometry={nodes['Cube 9'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-355.3, -99.27, -154.26]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 121"
                        geometry={nodes['Cube 121'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-262.72, 15.7, -123.82]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={[1, 1, 0.61]}
                    />
                    <mesh
                        name="Cube 141"
                        geometry={nodes['Cube 141'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-76.51, -99.27, -56.04]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 81"
                        geometry={nodes['Cube 81'].geometry}
                        material={materials.purple}
                        castShadow
                        receiveShadow
                        position={[-327.94, -99.27, -147.56]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 4"
                        geometry={nodes['Cube 4'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-202.22, -26.18, -98.54]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 51"
                        geometry={nodes['Cube 51'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-103.87, -100.18, -66.01]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 31"
                        geometry={nodes['Cube 31'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-202.22, -100.18, -101.8]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 56"
                        geometry={nodes['Cube 56'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-392.63, -123.42, -49.28]}
                        rotation={[-Math.PI / 2, 0, 0.29]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 32"
                        geometry={nodes['Cube 32'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-15.49, -29.88, 126.36]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 311"
                        geometry={nodes['Cube 311'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-15.49, -59, 126.36]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 30"
                        geometry={nodes['Cube 30'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-15.49, -88.12, 126.36]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 11"
                        geometry={nodes['Cube 11'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-368.99, -20.12, -159.24]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 301"
                        geometry={nodes['Cube 301'].geometry}
                        material={materials.orange}
                        castShadow
                        receiveShadow
                        position={[-15.49, -116.01, 123.11]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 2"
                        geometry={nodes['Cube 2'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-368.99, -48.01, -162.5]}
                        rotation={[-Math.PI / 2, 0, -Math.PI / 9]}
                        scale={1}
                    />
                    <mesh
                        name="Star 3"
                        geometry={nodes['Star 3'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-21.06, -139.19, -119.29]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 3"
                        geometry={nodes['Cone 3'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[127.2, -101.38, 395.74]}
                    />
                    <mesh
                        name="Cone 11"
                        geometry={nodes['Cone 11'].geometry}
                        material={materials.yellow}
                        castShadow
                        receiveShadow
                        position={[28.61, -127.41, 340.18]}
                        rotation={[0, 0.67, -1.85]}
                        scale={1}
                    />
                    <mesh
                        name="Cone 2"
                        geometry={nodes['Cone 2'].geometry}
                        material={materials.red}
                        castShadow
                        receiveShadow
                        position={[36.56, -101.38, 258.42]}
                    />
                    <group name="Group 54" position={[-280.52, -97.33, -50.24]}>
                        <mesh
                            name="Sphere1"
                            geometry={nodes.Sphere1.geometry}
                            material={materials['yellow-lighr']}
                            castShadow
                            receiveShadow
                            position={[0, 25.36, 0]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            scale={1}
                        />
                        <mesh
                            name="Cube 33"
                            geometry={nodes['Cube 33'].geometry}
                            material={materials.yellow}
                            castShadow
                            receiveShadow
                            position={[0, -25.36, 0]}
                            rotation={[-Math.PI / 2, 0, 0]}
                            scale={1}
                        />
                    </group>
                </group>
                <group name="Cylinders" position={[-750.97, -192.57, 1009.7]} rotation={[0, 0, 0]}>
                    <mesh
                        name="Cylinder 31"
                        geometry={nodes['Cylinder 31'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-1210.84, 253.58, -873.58]}
                        scale={[1, 0.7, 1]}
                    />
                    <mesh
                        name="Cylinder 21"
                        geometry={nodes['Cylinder 21'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-1175.3, 261.85, -410.33]}
                        scale={[1, 0.7, 1]}
                    />
                    <mesh
                        name="Cylinder 20"
                        geometry={nodes['Cylinder 20'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-217.18, 331.84, -789.79]}
                        scale={[1, 0.7, 1]}
                    />
                    <mesh
                        name="Cylinder 18"
                        geometry={nodes['Cylinder 18'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-76.88, 334.69, -342.74]}
                        scale={[1, 0.7, 1]}
                    />
                </group>
                <group name="Group 66" position={[-1296.26, -225.16, 784.71]}>
                    <mesh
                        name="Cylinder 27"
                        geometry={nodes['Cylinder 27'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[69.75, 52.29, -154.08]}
                        rotation={[-1.51, -0.14, 1.82]}
                        scale={[0.66, 0.33, 0.66]}
                    />
                    <mesh
                        name="Cylinder 26"
                        geometry={nodes['Cylinder 26'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[47.07, 220.39, 549.73]}
                        rotation={[-1.54, 0, 0.27]}
                        scale={[0.66, 0.22, 0.66]}
                    />
                    <mesh
                        name="Cylinder 25"
                        geometry={nodes['Cylinder 25'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[289.2, 195.87, 173.05]}
                        scale={[0.66, 0.22, 0.51]}
                    />
                    <mesh
                        name="Cylinder 24"
                        geometry={nodes['Cylinder 24'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-85.5, 0.5, 81.13]}
                        scale={[0.66, 0.33, 0.66]}
                    />
                </group>
                <group name="Group 68" position={[-1431.77, -224.98, 837.87]} scale={1.16}>
                    <mesh
                        name="Cube 48"
                        geometry={nodes['Cube 48'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-219.72, -82.09, -166.85]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 47"
                        geometry={nodes['Cube 47'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[219.65, -82.09, -166.85]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 481"
                        geometry={nodes['Cube 481'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[-219.72, -82.09, 166.77]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 46"
                        geometry={nodes['Cube 46'].geometry}
                        material={materials.pink}
                        castShadow
                        receiveShadow
                        position={[219.65, -82.09, 166.77]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 44"
                        geometry={nodes['Cube 44'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[-2.29, -103.65, 0]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Cube 22"
                        geometry={nodes['Cube 22'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[-284.97, -80.42, 0.21]}
                        rotation={[0, 0, -Math.PI / 2]}
                        scale={[0.61, 0.61, 1]}
                    />
                    <mesh
                        name="Cube 45"
                        geometry={nodes['Cube 45'].geometry}
                        material={materials.bluse}
                        castShadow
                        receiveShadow
                        position={[157.44, -81.15, 0.21]}
                        rotation={[0, 0, -Math.PI / 2]}
                        scale={[0.61, 0.61, 1]}
                    />
                    <mesh
                        name="Cylinder 19"
                        geometry={nodes['Cylinder 19'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[0.03, -27.66, -166.99]}
                        rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                        scale={1.12}
                    />
                    <mesh
                        name="Cylinder 181"
                        geometry={nodes['Cylinder 181'].geometry}
                        material={materials.green}
                        castShadow
                        receiveShadow
                        position={[0.03, -27.66, 166.28]}
                        rotation={[-Math.PI / 2, -Math.PI / 2, 0]}
                        scale={1.12}
                    />
                </group>
                <group name="Group 67" position={[-1414.63, -196.65, 287.55]} scale={1.16}>
                    <mesh
                        name="Cube 43"
                        geometry={nodes['Cube 43'].geometry}
                        material={materials.orange}
                        castShadow
                        receiveShadow
                        position={[0.36, -103.31, -146.75]}
                        rotation={[-Math.PI / 2, 0, 0]}
                        scale={1}
                    />
                    <mesh
                        name="Boolean 15"
                        geometry={nodes['Boolean 15'].geometry}
                        material={materials.red}
                        castShadow
                        receiveShadow
                        position={[-0.28, 45.09, -0.01]}
                    />
                    <mesh
                        name="Cylinder 14"
                        geometry={nodes['Cylinder 14'].geometry}
                        material={materials['Cylinder 14 Material']}
                        castShadow
                        receiveShadow
                        position={[-0.28, 45.09, -0.01]}
                        rotation={[Math.PI / 2, 0, 0]}
                        scale={1.56}
                    />
                </group>
                <mesh
                    name="Cube"
                    geometry={nodes.Cube.geometry}
                    material={materials.purple}
                    castShadow
                    receiveShadow
                    position={[-1402.6, 839.85, 390.57]}
                    rotation={[-Math.PI / 2, 0, 0]}
                    scale={1.56}
                />
                <hemisphereLight name="Default Ambient Light" intensity={0.75} color="#eaeaea" />
            </group>
        </>
    )
}
